<template>
    <ContainerLayout page="0" :padding="false">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div class="content px-1">
            <div v-for="(locale, index) in supportedLocales" :key="index"
                class="d-flex flex-row justify-content-between align-items-center mb-1" style="cursor: pointer;"
                @click.prevent="setLocale(locale)">
                <div class="w-100 card"
                    style="border-radius: 0.25rem; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;"
                    :style="selected_locale == locale ? ' border: 1.5px solid #275D93;' : ' border: 1.5px solid rgba(0,0,0,.125);'">
                    <div class="d-flex flex-row align-items-center p-3">
                        <div v-if="locale == 'id'" class="d-flex flex-row align-items-center">
                            <div class="circle-flag">
                                <div class="circle-flag-container">
                                    <img class="circle-flag-image"
                                        src="https://cdn.countryflags.com/thumbs/indonesia/flag-400.png" />
                                </div>
                            </div>
                            <span class="ml-3"
                                :style="selected_locale == locale ? 'font-weight: bolder; color: #275D93;' : ''">Indonesia</span>
                        </div>
                        <div v-if="locale == 'en'" class="d-flex flex-row align-items-center">
                            <div class="circle-flag">
                                <div class="circle-flag-container">
                                    <img class="circle-flag-image"
                                        src="https://cdn.countryflags.com/thumbs/united-states-of-america/flag-400.png" />
                                </div>
                            </div>
                            <span class="ml-3"
                                :style="selected_locale == locale ? 'font-weight: bolder; color: #275D93;' : ''">English</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";
import AuthService from "@/services/auth.service";

export default {
    name: "CompanyRegistration",
    components: {
        ContainerLayout,
    },
    data() {
        return {
            loading: false,
            selected_locale: null,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentLocale() {
            return localStorage.getItem('locale') ? localStorage.getItem('locale') : 'id';
        },

        supportedLocales() {
            return ['id', 'en'];
        },
    },
    created() {
        this.selected_locale = this.currentLocale;
    },
    methods: {
        goBack() {
            this.$router.push({
                name: "Profile",
            });
        },

        setLocale(locale) {
            this.loading = true;
            let loader = this.$loading.show();

            AuthService
                .setLocale(locale)
                .then((response) => {
                    this.loading = false;
                    loader.hide();
                    if (response.data.status == 'success') {
                        this.selected_locale = locale;
                        this.$vueAlert.alert(response.data.message, null, 'success').then(() => {
                            this.$router.go();
                        });
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },
    }
};
</script>

<style scoped>
.circle-flag {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.circle-flag-container {
    width: 100%;
    height: 100%;
    position: relative;
    transform: scale(1.2);
}

.circle-flag-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    position: absolute;
    top: 0;
    left: 0;
}
</style>
  